module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "color": _vm.color
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [(_vm.href) ? _c('a', {
    attrs: {
      "href": _vm.href,
      "target": "_blank"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v(_vm._s(_vm.message))]) : [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")], _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent",
      "timeout": 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide($event)
      }
    }
  }, [_vm._v("Close")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fb7d4da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/SnackBar.vue
// module id = 1063
// module chunks = 1